import styled from 'styled-components';

export const Container = styled.div`
  h3 {
    font-size: 18px;
    line-height: 28px;
    font-weight: 900;
    color: #000;
    margin-bottom: 16px;
  }
`;
export const ContentArea = styled.div`
  background-color: #fbfaff;
  border: 1px #e6e0ff solid;
  padding: 32px;
  border-radius: 4px;
`;
export const TaxableAmount = styled.div`
  display: flex;
  justify-content: space-between;
  margin-bottom: 32px;
`;
export const TaxableAmountLft = styled.div`
  flex: 1;
`;
export const TaxableAmountRht = styled.div`
  flex-shrink: 0;
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  .inputWrap {
    position: relative;
  }
  .inputLoader {
    position: absolute;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
    z-index: 1;
  }
  .textInput {
    width: 201px;
    height: 48px;
    background: #f0f0f0;
    border: 1px solid #e4e4e4;
    border-radius: 4px;
    outline: 0;
    border: 0;
    padding: 0 12px;
    font-family: 'Lato';
    font-size: 20px;
    font-weight: 900;
    :read-only {
      color: #a8a8a8;
    }
    color: #000;
    text-align: right;
  }
  .textInput:focus {
    background-color: #fff;
    border: 1px #008cff solid;
  }
  .edit {
    font-size: 14px;
    font-weight: 900;
    margin-top: 8px;
  }
`;
export const ListContent = styled.div``;
export const ListContentRow = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  border-top: 1px #d4d0e1 solid;
  padding: 16px 0;
  :last-child {
    padding-bottom: 0;
  }
`;
export const ListContentKey = styled.span`
  font-size: 14px;
  line-height: 20px;
  color: #000;
`;
export const ListContentValue = styled.span`
  font-size: 14px;
  line-height: 20px;
  color: #000;
  font-weight: 700;
`;
